/**
 * Sentry adapter **stub**. Uncomment the `@sentry/browser` imports below
 * and install the package (`npm i @sentry/browser`) to activate. The rest
 * of the codebase talks to the generic `Reporter` interface, so dropping
 * this in requires no other changes.
 */
import type { Reporter } from './types';

// import * as Sentry from '@sentry/browser';

export interface SentryReporterOptions {
  dsn: string;
  environment?: string;
  release?: string;
}

export function createSentryReporter(_options: SentryReporterOptions): Reporter {
  // Sentry.init({
  //   dsn: _options.dsn,
  //   environment: _options.environment,
  //   release: _options.release,
  //   tracesSampleRate: 0.1,
  // });

  return {
    captureError(_error, _context) {
      // Sentry.captureException(_error, { extra: _context });
    },
    captureMessage(_message, _context) {
      // Sentry.captureMessage(_message, { extra: _context });
    },
    captureMetric(_name, _value, _context) {
      // Sentry.metrics.distribution(_name, _value, { tags: _context });
    },
    setUser(_user) {
      // Sentry.setUser(_user);
    },
  };
}
